/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class CallingConventions.
* @enum {}
* @readonly
*/
export default class CallingConventions {
    
        /**
         * value: 1
         * @const
         */
        "1" = 1;

    
        /**
         * value: 2
         * @const
         */
        "2" = 2;

    
        /**
         * value: 3
         * @const
         */
        "3" = 3;

    
        /**
         * value: 32
         * @const
         */
        "32" = 32;

    
        /**
         * value: 64
         * @const
         */
        "64" = 64;

    

    /**
    * Returns a <code>CallingConventions</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/CallingConventions} The enum <code>CallingConventions</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

